import InputBatch from "./pages/inputBatches/InputBatch";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import DashboardLayout from "./components/layout/DashboardLayout";
import RequireAuth from "./features/auth/RequireAuth";
import MachineAnalytics from "./pages/machineAnalytics/MachineAnalytics";
import RealTimeAnalytics from "./pages/realTimeAnalytics/RealTimeAnalytics";
import Reports from "./pages/reports/Reports";
import Batch from "./pages/batches/Batch";
import BatchDetails from "./pages/batches/BatchDetails";
import DispatchHistory from "./pages/dispatchHistory/DispatchHistory";
import Item from "./pages/items/Item";
import ItemRouting from "./pages/itemRouting/ItemRouting";
import Line from "./pages/lines/Line";
import RelationType from "./pages/relationTypes/RelationType";
import Login from "./pages/login/Login";
import Machine from "./pages/machines/Machine";
import Oem from "./pages/oems/Oem";
import Operation from "./pages/operations/Operation";
import Plant from "./pages/plants/Plant";
import QRVerification from "./pages/qrVerification/QRVerification";
import RawMaterial from "./pages/rawMaterials/RawMaterial";
import Role from "./pages/roles/Role";
import Scanner from "./pages/scanner/Scanner";
import Settings from "./pages/settings/Settings";
import Shift from "./pages/shifts/Shift";
import Page from "./pages/userManagement/Page";
import User from "./pages/userManagement/User";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<RequireAuth />}>
          <Route element={<DashboardLayout />}>
            <Route path="/setting" element={<Navigate to="/setting/analytics" replace />} />
            <Route path="/setting/analytics" element={<MachineAnalytics />} />
            <Route path="/setting/real-time-analytics" element={<RealTimeAnalytics />} />
            <Route path="/setting/batch" element={<Batch />} />
            <Route path="/setting/batch/:batchUid" element={<BatchDetails />} />
            <Route path="/setting/dispatch-history" element={<DispatchHistory />} />
            <Route path="/setting/reports" element={<Reports />} />
            <Route path="/setting/scanner" element={<Scanner />} />
            <Route path="/setting/qr-verification" element={<QRVerification />} />
            <Route path="/setting/settings" element={<Settings />} />
            <Route path="/setting/plant" element={<Plant />} />
            <Route path="/setting/shift" element={<Shift />} />
            <Route path="/setting/line" element={<Line />} />
            <Route path="/setting/relation-type" element={<RelationType />} />
            <Route path="/setting/machine" element={<Machine />} />
            <Route path="/setting/raw-material" element={<RawMaterial />} />
            <Route path="/setting/input-batch" element={<InputBatch />} />
            <Route path="/setting/item" element={<Item />} />
            <Route path="/setting/item-routing" element={<ItemRouting />} />
            <Route path="/setting/oem" element={<Oem />} />
            <Route path="/setting/operation" element={<Operation />} />
            <Route path="/setting/page" element={<Page />} />
            <Route path="/setting/role" element={<Role />} />
            <Route path="/setting/user" element={<User />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
